import React, { useState, useEffect } from "react"
import axios from "axios"

import Select from 'react-select'
import { ShimmerButton } from "react-shimmer-effects"

import { TAXONOMY_ENDPOINT } from '../utils/constants';

var he = require('he');

const Filters = ( props ) => {

  const [categories, setCategories] = useState( '' )

  const regions = [
    {
      value: 'landsdaekkende',
      label: 'Landsdækkende'
    },
    {
      value: 'nordjylland',
      label: 'Region Nordjylland'
    },
    {
      value: 'midtjylland',
      label: 'Region Midtjylland'
    },
    {
      value: 'syddanmark',
      label: 'Region Syddanmark'
    },
    {
      value: 'hovedstaden',
      label: 'Region Hovedstaden'
    },
    {
      value: 'sjaelland',
      label: 'Region Sjælland'
    }
  ]

  useEffect(() => {
    const getCategories = async () => {
      await axios.get(
      TAXONOMY_ENDPOINT, {}
      )
      .then((res) => {
        let categoriesArr = []

        res.data.map( category => {
          return categoriesArr.push( { value: category.id, label: he.decode( category.name ) } )
        })

        setCategories( categoriesArr )
      })
      .catch((err) => {

      });
    }

    getCategories()
  }, [])

  const categoryChange = ( option, action ) => {
    let obj;

    if ( option === null ) {
      obj = { ...props.params, category: [] };
    } else {
      obj = { ...props.params, category: [ option.value ] }
    }

    props.filtersChange( obj )
  }

  const typeChange = ( option, action ) => {
    let obj;

    if ( option === null ) {
      obj = { ...props.params, type: [] };
    } else {
      obj = { ...props.params, type: [ option.value ] }
    }

    props.filtersChange( obj )
  }

  const regionChange = ( option, action ) => {
    let obj;

    if ( option === null ) {
      obj = { ...props.params, region: [] };
    } else {
      obj = { ...props.params, region: [ option.value ] }
    }

    props.filtersChange( obj )
  }

  const expiredEventsChange = ( value ) => {
    props.filtersChange( { ...props.params, expired: value } )
  }

  if ( categories === '' ) {
    return (
      <div className="events-archive__filters-loading">
        <ShimmerButton size="lg" />
        <ShimmerButton size="lg" />
        <ShimmerButton size="lg" />
      </div>
    )
  }

  return (
    <>
      <div className="events-archive__filters">
        {
          categories && categories !== '' && (
            <div className="events-archive__filter">
              <Select
                isClearable={ true }
                classNamePrefix="events-archive"
                placeholder="Filtrer efter kategori"
                options={ categories }
                onChange={ ( option, action ) => categoryChange( option, action ) }
                isSearchable={ false }
              />
            </div>
          )
        }
        {
          regions && regions !== '' && (
            <div className="events-archive__filter">
              <Select
                isClearable={ true }
                classNamePrefix="events-archive"
                placeholder="Filtrer efter region"
                options={ regions }
                onChange={ ( option, action ) => regionChange( option, action ) }
                isSearchable={ false }
              />
            </div>
          )
        }
        <label className="events-archive__checkbox-label">
          <input type="checkbox" onClick={ ( event ) => expiredEventsChange( event.target.checked ) } />
          <span>Vis afholdte arrangementer</span>
        </label>
      </div>
    </>
  )
}

export default Filters;
